import React from "react"
import Img from "gatsby-image"
import SectionTitle from "./sectionTitle"
import { Box, Container, Flex, Grid } from "@theme-ui/components"
import CategoryThumb from "./categoryThumb"

const FeaturedCategoriesList = ({ section }) => (
  <Box mt={[0, 5]} mb={[0, 5]}>
    <Container py={6}>
      <Grid columns={[1, 1, "1fr 2fr"]} gap={[5]}>
        <Box>
          <SectionTitle title={section.title} alignement="left" />
          <div dangerouslySetInnerHTML={{ __html: section.body }} />
        </Box>
        <Box>
          <Grid columns={[1, 2, 2]} gap={32}>
            {section.categories.map(category => (
              <CategoryThumb subcategory={category} />
            ))}
          </Grid>
        </Box>
      </Grid>
    </Container>
  </Box>
)

export default FeaturedCategoriesList
